import request from "@/api/request";

export function getAlarmViewer(type = 'ALL', token = '745a9bab-e5f1-4ce7-8fce-ef14fc8278c5') {
    return request({
        url: `/alarmviewer?type=${type}&token=${token}`,
        method: 'get'
    })
}

export function printAlarmViewer(type = 'ALL', token = '745a9bab-e5f1-4ce7-8fce-ef14fc8278c5') {
    return request({
        url: `/alarmviewer/print?type=${type}&token=${token}`,
        method: 'get'
    })
}
